import axios from 'axios';
const client = axios.create({
  baseURL: 'https://statsapi.mlb.com',
  headers: {
    'Content-Type': 'application/json',
  },
});

interface TeamResponse {
  id: number,
  name: string
}

interface PlayingTeamResponse {
  team: TeamResponse
}

interface PlayingTeamsResponse {
  home: PlayingTeamResponse
  away: PlayingTeamResponse
}

export interface GamesResponse {
  gameDate: string,
  teams: PlayingTeamsResponse
}

interface DateResponse {
  gamePk: number,

  games: GamesResponse[]
}

export interface TeamScheduleResponse {
  dates: DateResponse[]
}

export async function fetchTeamSchedule(teamId: number, startDate: Date, endDate: Date): Promise<TeamScheduleResponse> {
  const response = await client.get<TeamScheduleResponse>(`/api/v1/schedule/games/?sportId=1&startDate=${formatDate(startDate)}&endDate=${formatDate(endDate)}&teamId=${teamId}`);

  return response.data;
}

function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}
